import { Directive, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

export interface BMSliderTooltipContext {
  $implicit: number;
  min: number;
  max: number;
  isDragging: Observable<boolean>;
}

@Directive({
  selector: '[bmSliderValueTooltip]',
})
/**
 * Directive to draw a tooltip to the progress bar
 */
export class BMSliderValueTooltipDirective {
  constructor(public templateRef: TemplateRef<BMSliderTooltipContext>) {}
}
